import { create } from "zustand";

export const breadcrumbStore = create(set => ({
  current: [{ title: 'Dashboard' }],
  toggle: (page) => set(state => ({ ...state, current: page })),
  page: {
    BANNER_INDEX: [ { title: 'Dashboard' }, { title: 'Banner' }],
    BANNER_CREATE: [ { title: 'Dashboard' }, { title: 'Banner' }, { title: 'Tambah Data' }]
  }
}))